import React, { useState } from 'react';
import './hospital&doctormodal.css'; // Import the CSS file

const AddHospitalModal = ({ show, onClose, onSave, cityId }) => {
  const [hospitalName, setHospitalName] = useState('');
  const [hospitalAddress, setHospitalAddress] = useState('');
  const [hospitalPincode, setHospitalPincode] = useState('');
  const [hospitalCity, setHospitalCity] = useState('');
  const [hospitalMetaData, setHospitalMetaData] = useState('');

  if (!show) {
    return null;
  }

  const handleSave = () => {
    if(hospitalName.trim()===''){
      alert("Hospital Name cannot be empty")
      return
    }
    
    // Parse metadata JSON if provided
    let metaDataObj = null;
    if(hospitalMetaData.trim() !== ''){
      try {
        metaDataObj = JSON.parse(hospitalMetaData);
      } catch(e) {
        alert("Invalid JSON format for Hospital Metadata");
        return;
      }
    }
    
    onSave(hospitalName, cityId, {
      hospitalAddress: hospitalAddress.trim() || undefined,
      hospitalPincode: hospitalPincode.trim() || undefined,
      hospitalCity: hospitalCity.trim() || undefined,
      hospitalMetaData: metaDataObj
    });
    
    // Reset form
    setHospitalName('');
    setHospitalAddress('');
    setHospitalPincode('');
    setHospitalCity('');
    setHospitalMetaData('');
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-container" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
        <div className="modal-header">
          <h2 className="modal-title">Add New Hospital</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Hospital Name: <span style={{color:'red'}}>*</span></label>
            <input
              type="text"
              value={hospitalName}
              onChange={(e) => setHospitalName(e.target.value)}
              className="modal-input"
              placeholder="Enter hospital name"
            />
          </div>
          <div className="form-group">
            <label>Hospital Address:</label>
            <input
              type="text"
              value={hospitalAddress}
              onChange={(e) => setHospitalAddress(e.target.value)}
              className="modal-input"
              placeholder="Enter address (max 500 chars)"
              maxLength="500"
            />
          </div>
          <div className="form-group">
            <label>Hospital Pincode:</label>
            <input
              type="text"
              value={hospitalPincode}
              onChange={(e) => setHospitalPincode(e.target.value)}
              className="modal-input"
              placeholder="Enter pincode (max 10 chars)"
              maxLength="10"
            />
          </div>
          <div className="form-group">
            <label>Hospital City:</label>
            <input
              type="text"
              value={hospitalCity}
              onChange={(e) => setHospitalCity(e.target.value)}
              className="modal-input"
              placeholder="Enter city (max 100 chars)"
              maxLength="100"
            />
          </div>
          <div className="form-group">
            <label>Hospital Metadata (JSON - Optional):</label>
            <textarea
              value={hospitalMetaData}
              onChange={(e) => setHospitalMetaData(e.target.value)}
              className="modal-input"
              placeholder='e.g., {"phone": "+91-XXXX-XXXX", "specialty": "Cardiology"}'
              style={{ minHeight: '80px', fontFamily: 'monospace' }}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="modal-submit" onClick={handleSave}>Save</button>
          {/* <button className="modal-cancel" onClick={onClose}>Cancel</button> */}
        </div>
      </div>
    </div>
  );
};

export default AddHospitalModal;
